import { render, staticRenderFns } from "./searchSimple.vue?vue&type=template&id=632fa424&"
import script from "./searchSimple.vue?vue&type=script&lang=ts&"
export * from "./searchSimple.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports